module.exports = __webpack_public_path__ + "img/drink-aware.106fb075.svg";